import { useQuery } from "@tanstack/react-query";
import { getConfluenceConfigs } from "@/services/confluence.service";

export default function useConfluenceConfig() {
  return useQuery({
    queryKey: ["configurations", "confluence"],
    queryFn: async () => {
      const result = await getConfluenceConfigs();
      return result?.data ?? null;
    },
    staleTime: Infinity,
  });
}
